import { Link, NavLink, useLocation } from 'react-router';
import { useWindowSize } from 'react-use';

import ambarIcon from '../../assets/images/ambarIcon.svg';
import sidebarLinkIcon from '../../assets/images/sidebarLinkIcon.svg';
import { menuItems } from '../../utils/constants';
import Logo from '../Logo/Logo';
import styles from './styles/styles.module.css';

function LoginHeader() {
  const { width } = useWindowSize();
  const { activeSrc, src, label } = menuItems[4];
  const closeButton = menuItems[5];
  const { pathname } = useLocation();

  return (
    <header className={styles.loginHeaderWrapper}>
      <Logo smallSize />
      {width < 480 ? (
        <NavLink to={pathname.includes('/login/menu') ? '/login' : '/login/menu'}>
          {({ isActive }) => (
            <>
              {pathname.includes('/login/menu') ? (
                <img src={closeButton.src} alt={label} className={styles.navbarIcon} />
              ) : (
                <img
                  src={isActive ? activeSrc : src}
                  alt={label}
                  className={styles.navbarIcon}
                />
              )}
            </>
          )}
        </NavLink>
      ) : (
        <div className={styles.loginHeaderContacts}>
          <ul className={styles.navLinks}>
            <li>
              <Link
                to="https://yandex.ru/map-widget/v1/?lang=ru_RU&scroll=true&source=constructor-api&um=constructor%3Aa6d4b93a8023b120247a857419d338697303b3c37138e16ecf30528186819a78"
                className={styles.infoLink}
                target="_blank"
                rel="noopener"
              >
                <img src={sidebarLinkIcon} alt="иконка локации" />
                <p className={styles.loginHeaderText}>
                  Москва, г. Троицк, ул. Промышленная, 15.
                </p>
              </Link>
            </li>
            <li>
              <Link
                to="https://ambar-sklad.ru/"
                className={styles.infoLink}
                target="_blank"
                rel="noopener"
              >
                <img src={ambarIcon} alt="иконка логотипа" />
                <p className={styles.loginHeaderText}> ambar-sklad.ru</p>
              </Link>
            </li>
            <li>
              <Link
                className={styles.infoLink}
                to="tel:+74994606716"
                target="_blank"
                rel="noopener"
              >
                <p className={styles.loginHeaderText}>+7 (499) 460-67-16</p>
              </Link>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
}

export default LoginHeader;
